import { render, staticRenderFns } from "./FileUploadComp.vue?vue&type=template&id=4dafed41&"
import script from "./FileUploadComp.vue?vue&type=script&lang=js&"
export * from "./FileUploadComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports